import React, { PureComponent } from 'react';
import { Dimensions, ImageSourcePropType, Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Icon } from '../components';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { HomeInviteButtonsContainer } from './HomeInviteButtonsContainer';
import { HomeInviteCarousel } from './HomeInviteCarousel';

interface IProps {
  navigation: any;
  inviterImageSource?: ImageSourcePropType;
  renderInviteText: () => JSX.Element;
  renderFixedContent?: () => JSX.Element;
  landingPage: string | undefined;
  workoutInviteId: string | undefined;
  utm_source: string | undefined;
  handleBackNavigation?(): void;
  t(key: string, options?: any): string;
}

const { width } = Dimensions.get('window');
const isMobile = Platform.OS !== 'web' || width <= 550;

export class InviteScreen extends PureComponent<IProps> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { t, renderInviteText, navigation, renderFixedContent,
       inviterImageSource, handleBackNavigation,
      landingPage, workoutInviteId, utm_source } = this.props;

    return (
      <View style={styles.container}>
        {handleBackNavigation && (
          <TouchableOpacity onPress={handleBackNavigation} style={styles.backIconContainer}>
            <Icon
              name='ios-arrow-back'
              color={Theme.WHITE}
              size={defaultScale(35)}
            />
          </TouchableOpacity>
        )}
        {isMobile && (
          <HomeInviteCarousel
            t={t}
            fixedContent={renderFixedContent && renderFixedContent()}
            inviterImageSource={inviterImageSource}
          />
        )}
        <HomeInviteButtonsContainer
          renderInviteText={renderInviteText}
          navigation={navigation}
          landingPage={landingPage}
          utm_source={utm_source}
          workoutInviteId={workoutInviteId}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.WHITE,
    height: '100%',
    position: 'relative',
  },
  backIconContainer: {
    alignSelf: 'flex-start',
    marginHorizontal: defaultScale(15),
    top: defaultScale(40),
    position: 'absolute',
    zIndex: 10,
  },
});
